/*

Controller file for UpcomingTasks

*/
import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var UpcomingTasks = Class.create({
    initialize: function() {
        this.server = server;
    },
    getTasks: function(callback, taskObject) {
        var self = this;
        var url = "tasks/today"
        // #  Send to server object for processing
        // #  Listen to our data
        self.server.getData(url, null, true)
            .done(function(response){
                // #  Validate response
                if(response.data.error_user_authentication == 1)
                {
                }
                else if(response.data.error || (response.status == 1 || response.status == 2))
                {
                    modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
                }
                if(callback) {
                    callback(response);
                }
            })
            .fail(function(e){
                modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
            });
    },
    postTask: function (taskObject, callback) {
        var self = this;
        let url = 'tasks/today/execute'
        var data = self.server.getData(url, Object.assign({}, taskObject), true, "POST");
        // #  Listen to our data
        data.done(function(response){
            if(response.data.error_user_authentication == 1) {
            } else if(response.data.error || (response.status == 1 || response.status == 2)) {
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
            }
            if(callback) {
                callback(response);
            }
        }).fail(function(e){
            modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
            if(callback) {
                callback(e);
            }
        });
        // #  Send to server object for processing
    }
});

export let UpcomingTask = new UpcomingTasks();


// WEBPACK FOOTER //
// app/core/controllers/UpcomingTasks.js